import { ReactNode } from 'react';
import Loader from '../../components/common/Loader';

interface LoadingContainerProps {
  size?: number;
  message?: ReactNode;
  smallHeight?: boolean;
  className?: string;
}

const LoadingContainer = ({
  size = 75,
  message = 'Loading...',
  smallHeight = false,
  className = '',
}: LoadingContainerProps) => {
  return (
    <div
      className={`text-center py-4 w-full flex justify-center items-center flex-col ${
        smallHeight ? 'h-64' : ''
      } ${className}`}>
      <Loader size={size} />
      {message && <span className="text-center py-[15px] !block w-full">{message}</span>}
    </div>
  );
};

export default LoadingContainer;
